import { atom } from 'jotai';

export const currentJourneysTabAtom = atom<'messages' | 'events' | 'flows'>('messages');

export const atomInfoRecurringMessageV1 = atom<{ id: number; name: string }>({ id: 0, name: '' });

export const atomEditModalIsOpen = atom<boolean>(false);
export const atomDuplicateModalIsOpen = atom<boolean>(false);
export const atomDeleteModalIsOpen = atom<boolean>(false);
export const atomSelectRuleTypeModalIsOpen = atom<boolean>(false);
